// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Chesnovskaya <anastasia.chesnovskaya@celadon.ae>

import GlobalStyles from '../../config/styles';

const styles = theme => ({
  paypalImage: {
    width: 140,
  },
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: 15,
    marginBottom: 20,
    borderRadius: 10,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
  },
  paymentTypeContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  paymentSelectIndex: {
    height: 20,
    width: 20,
    borderRadius: 10,
    background: 'rgb(220, 220, 220)',
    border: 'rgb(220, 220, 220)',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
  },
  onClickPaymentSelectIndex: {
    background: GlobalStyles.color.COLOR_GREEN,
    border: GlobalStyles.color.COLOR_GREEN,
  },
  editText: {
    color: GlobalStyles.color.COLOR_GREY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
    marginLeft: 'auto',
    cursor: 'pointer',
    '&:focus': {
      outline: 'none',
    },
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    border: GlobalStyles.color.COLOR_PRIMARY,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    },
  },
  paymentMethodText: {
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    letterSpacing: 1.1,
    marginLeft: 20,
    [theme.breakpoints.down(450)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    }
  },
  paymentMethodTextColor: {
    color: 'rgba(0, 0, 0, 0.87)',
  },
});

export default styles;
